import * as React from "react";

export const SVGComponent1: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width={14}
    height={10}
    viewBox="0 0 14 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1745_26242)">
      <path
        d="M0.75 0C0.34375 0 0 0.34375 0 0.75V9.25C0 9.65625 0.34375 10 0.75 10C1.15625 10 1.5 9.65625 1.5 9.25V0.75C1.5 0.34375 1.15625 0 0.75 0Z"
        fill="white"
      />
      <path
        d="M6.74097 0C6.33472 0 5.99097 0.34375 5.99097 0.75V4.23523H3.26562C2.85938 4.23523 2.51562 4.57898 2.51562 4.98523C2.51562 5.39148 2.85938 5.73523 3.26562 5.73523H5.99097V9.25C5.99097 9.65625 6.33472 10 6.74097 10C7.14722 10 7.49097 9.65625 7.49097 9.25V0.75C7.49097 0.34375 7.14722 0 6.74097 0Z"
        fill="white"
      />
      <path
        d="M13.631 4.45312L11.381 2.20312C11.0998 1.92188 10.5998 1.92188 10.3185 2.20312C10.0373 2.48438 10.0373 2.98438 10.3185 3.26562L11.2873 4.23438H6.95312C6.54688 4.23438 6.20312 4.57812 6.20312 4.98438C6.20312 5.39062 6.54688 5.73438 6.95312 5.73438H11.2873L10.3185 6.70312C10.0373 6.98438 10.0373 7.48438 10.3185 7.76562C10.5998 8.04688 11.0685 8.04688 11.381 7.76562L13.631 5.51562C13.9123 5.23438 13.9123 4.73438 13.631 4.45312Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1745_26242">
        <rect width={13.8419} height={10} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SVGComponent2: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width={14}
    height={10}
    viewBox="0 0 14 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1745_26250)">
      <path
        d="M12.6328 0C12.2266 0 11.8828 0.34375 11.8828 0.75V9.25C11.8828 9.65625 12.2266 10 12.6328 10C13.0391 10 13.3828 9.65625 13.3828 9.25V0.75C13.3828 0.34375 13.0391 0 12.6328 0Z"
        fill="white"
      />
      <path
        d="M4.35231 4.23438H0.75C0.34375 4.23438 0 4.57812 0 4.98438C0 5.39062 0.34375 5.73438 0.75 5.73438H4.35231C4.75856 5.73438 5.10231 5.39062 5.10231 4.98438C5.10231 4.57812 4.75856 4.23438 4.35231 4.23438Z"
        fill="white"
      />
      <path
        d="M8.03162 2.20398C7.75037 1.92273 7.25037 1.92273 6.96912 2.20398C6.68787 2.48523 6.68787 2.98523 6.96912 3.26648L7.93787 4.23523H5.39844V0.75C5.39844 0.34375 5.05469 0 4.64844 0C4.24219 0 3.89844 0.34375 3.89844 0.75V9.25C3.89844 9.65625 4.24219 10 4.64844 10C5.05469 10 5.39844 9.65625 5.39844 9.25V5.73523H7.93787L6.96912 6.70398C6.68787 6.98523 6.68787 7.48523 6.96912 7.76648C7.25037 8.04773 7.71912 8.04773 8.03162 7.76648L10.2816 5.51648C10.5629 5.23523 10.5629 4.73523 10.2816 4.45398L8.03162 2.20398Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1745_26250">
        <rect width={13.3856} height={10} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
